import React from 'react'
import LockRoundedIcon from '@mui/icons-material/LockRounded'
import { StatusChip } from '../../Common'
import { useNls } from '../../../nls/nlsProvider'
import { getRetentionLock } from '../../../types/ops'
import type {
  EvidenceSourceCollection,
  OpsRetentionSettingsDoc,
  OpsLegalHoldDoc,
} from '../../../types/ops'

export interface RetentionLockChipProps {
  source: EvidenceSourceCollection
  doc: Record<string, unknown>
  settings?: OpsRetentionSettingsDoc
  holds?: OpsLegalHoldDoc[]
  size?: 'md' | 'sm'
  className?: string
}

export const RetentionLockChip: React.FC<RetentionLockChipProps> = ({
  source,
  doc,
  settings,
  holds,
  size = 'sm',
  className,
}) => {
  const { t } = useNls()
  const lock = getRetentionLock(source, doc, settings, holds)

  if (!lock.locked) {
    return null
  }

  const dateStr = lock.lockedUntil ? lock.lockedUntil.toLocaleDateString() : ''
  const label = lock.held
    ? t('NLSOpsEvidenceLockChipHeld', { classKey: lock.classKey })
    : t('NLSOpsEvidenceLockChipLocked', {
        date: dateStr,
        classKey: lock.classKey,
      })

  return (
    <StatusChip
      tone={lock.held ? 'warning' : 'info'}
      icon={<LockRoundedIcon fontSize="inherit" />}
      size={size}
      className={className}
      data-testid="retention-lock-chip"
    >
      {label}
    </StatusChip>
  )
}
